<script setup lang="ts">
import { ref } from "vue";

defineEmits<{
  submit: [reason: string | null];
  cancel: [];
}>();

const reason = ref("");
</script>

<template>
  <div
    class="modal-backdrop"
    role="dialog"
    aria-modal="true"
    aria-labelledby="report-title"
  >
    <div class="modal">
      <h2 id="report-title">Report this grade</h2>
      <p class="muted">
        Tell us what you think the tutor got wrong. Reported grades go to an
        admin for review and help improve future grading.
      </p>
      <textarea
        v-model="reason"
        rows="5"
        placeholder="Why do you think this grade is wrong? (optional)"
        data-testid="report-reason"
      />
      <div class="modal-actions">
        <button
          class="secondary"
          data-testid="report-cancel"
          @click="$emit('cancel')"
        >
          Cancel
        </button>
        <button
          class="primary"
          data-testid="report-submit"
          @click="$emit('submit', reason.trim() || null)"
        >
          Submit report
        </button>
      </div>
    </div>
  </div>
</template>
